import React from 'react';
import ReactDOM from 'react-dom';
import TimePicker from 'rc-time-picker';
import FixRequiredSelect from "./FixRequiredSelect";
import BaseSelect from "react-select";
import Select from 'react-select';

var moment = require('moment');
// import 'babel-polyfill';


// class TimeEntry extends React.Component {
//
//   render() {
//     return (
//       <input onChange={this.props.changeevt} name={"options[" + this.props.id + "][" + this.props.type + "]"} size="10" type="text" value={this.props.hours + ":" + this.props.minutes} />
//       );
//   }
// }
// const Select = props => (
//     <FixRequiredSelect
//         {...props}
//         SelectComponent={BaseSelect}
//         options={props.options || options}
//     />
// );

class TimeEntries extends React.Component {

    constructor(props) {
        super(props);
        console.log(props);
        this.onBillableChange = this.onBillableChange.bind(this);
        this.onNonBillableChange = this.onNonBillableChange.bind(this);
        this.disabledHours = this.disabledHours.bind(this);
        this.state = {
            selectedTask: null,
            tasks: props.tasks || [],
            totalseconds: this.props.seconds,
            billable: moment().hours(0).minutes(0).seconds(0),
            nonbillable: moment().hours(0).minutes(0).seconds(0).seconds(this.props.seconds)
        }

    }

    onBillableChange(evt) {

        var seconds = moment.duration(evt.format("HH:mm"), "HH:mm").asSeconds();


        var billableSeconds = seconds;
        var nonBillableSeconds = 0;

        if (seconds > this.state.totalseconds) {
            billableSeconds = this.state.totalseconds;
        }

        nonBillableSeconds = this.state.totalseconds - billableSeconds;

        var billable = moment().hours(0).minutes(0).seconds(0).seconds(billableSeconds);
        var nonbillable = moment().hours(0).minutes(0).seconds(0).seconds(nonBillableSeconds);

        this.setState({
            billable: billable,
            nonbillable: nonbillable,
        });

    }

    onNonBillableChange(evt) {
        var seconds = 0;
        seconds = moment.duration(evt.format("HH:mm"), "HH:mm").asSeconds();

        var nonBillableSeconds = seconds;
        var billableSeconds = 0;

        if (seconds > this.state.totalseconds) {
            nonBillableSeconds = this.state.totalseconds;
        }

        billableSeconds = this.state.totalseconds - nonBillableSeconds;

        var billable = moment().hours(0).minutes(0).seconds(0).seconds(billableSeconds);
        var nonbillable = moment().hours(0).minutes(0).seconds(0).seconds(nonBillableSeconds);

        this.setState({
            billable: billable,
            nonbillable: nonbillable,
        });
    }

    disabledHours() {
//	  var allHours = Array.from(Array(30).keys());
        var allHours = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24];
        var totalHours = this.state.totalseconds / 3600;
        var disabledHours = allHours.map(function (val) {
            if (val > totalHours) {
                return val;
            }

        }, this);

        return disabledHours;
    }

    handleTaskSelect = (e) => {
        console.log(e);
        const allTime = moment().hours(0).minutes(0).seconds(this.state.totalseconds);
        const noTime = moment().hours(0).minutes(0).seconds(0);
		this.setState({
			billable: e.value ? allTime : noTime,
			nonbillable: e.value ? noTime : allTime,
            selectedTask: e.value || null

		});
	}

	render() {
        const taskOptions = this.state.tasks.map(({pkJobTicketid, taskCode, jotDescText}) => {
            return {label: (taskCode + ' - ' + jotDescText), value: pkJobTicketid};
        });

        console.log(taskOptions);

        taskOptions.unshift({label: 'No Task', value: null});



        const styles = {
            control: (base) => ({
                ...base,
                minHeight: '28px',
                height: '28px',
                width: '200px',
                fontSize: '12px'
            }),
            container: (base) => ({
                ...base,
                flexGrow: 1
            }),
            valueContainer: (provided, state) => ({
                ...provided,
                height: '28px',
                padding: '0 0 0 2px'
            }),
            dropdownIndicator: (base) => ({
                ...base,
                paddingTop: 0,
                paddingBottom: 0,
                paddingLeft: 0,
                paddingRight: 0,
                width: '20px'
            }),
        };

        return (
            <div style={{display: 'flex'}}>
                <TimePicker  name={"options[" + this.props.id + "][billable]"} hideDisabledOptions={true}
                            disabledHours={this.disabledHours} onChange={this.onBillableChange} style={{flex: '0 0 110px'}}
                            showSecond={false} value={this.state.billable} disabled={!this.state.selectedTask} minuteStep={15} />
                <TimePicker name={"options[" + this.props.id + "][nonbillable]"} onChange={this.onNonBillableChange}
                            disabledHours={this.disabledHours} hideDisabledOptions={true} style={{flex: '0 0 110px'}}
                            showSecond={false} value={this.state.nonbillable} minuteStep={15} />
                {/*<div style={{flexGrow: 1}}>*/}
                    <Select placeholder={'Task'} options={taskOptions} required={(this.state.billable.seconds() > 0) || (this.state.billable.hours() > 0 || (this.state.billable.minutes() > 0))}
                            name={"options[" + this.props.id + "][task]"} styles={styles} onChange={e => this.handleTaskSelect(e)}/>
                {/*</div>*/}
            </div>
        );
    }

}

function loadTimeSheetComponents() {
    if (typeof timesheet_data !== 'undefined') {
        timesheet_data.forEach(function (item) {
            console.log(item);
            console.log(tasksByStaffId[item.fkStaffid]);
            ReactDOM.render(
                <TimeEntries seconds={item.tsSecworked} id={item.pkTimesheetid} tasks={tasksByStaffId[item.fkStaffid]}/>,
                document.getElementById('root' + item.pkTimesheetid)
            );
        });
    }
}
window.loadTimeSheetComponents = loadTimeSheetComponents;

